(function () {
  const sections = document.querySelectorAll('[data-barf-recipes]');
  if (!sections.length) return;

  sections.forEach((section) => {
    section.classList.add('fbr-js');

    const revealItems = section.querySelectorAll('.fbr-reveal, .fbr-reveal-card');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('fbr-is-visible');
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.14,
      rootMargin: '0px 0px -48px 0px'
    });

    revealItems.forEach((item, index) => {
      if (!item.style.getPropertyValue('--fbr-delay')) {
        item.style.setProperty('--fbr-delay', `${index * 80}ms`);
      }
      observer.observe(item);
    });
  });
})();
